import { useEffect, useState } from "react";
import { api, getAdminToken } from "@/lib/api";

const auth = () => ({ headers: { Authorization: `Bearer ${getAdminToken()}` } });
const euros = (c, cur) => (c / 100).toFixed(2).replace(".", ",") + " " + (cur || "EUR");
const fmtDate = (iso) => { try { return new Date(iso).toLocaleString("fr-FR"); } catch { return iso || "—"; } };
const statusStyle = (s) =>
  s === "paid" ? "bg-[#385E3A]/15 text-[#385E3A]"
  : s === "failed" || s === "expired" ? "bg-[#A63B36]/15 text-[#A63B36]"
  : "bg-[#E8DCC4] text-[#1F2A24]/60";

export default function AdminOrders() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => { api.get("/admin/orders", auth()).then((r) => setRows(r.data || [])).catch(() => {}); }, []);

  const filtered = filter === "all" ? rows : rows.filter((r) => r.payment_status === filter);
  const paid = rows.filter((r) => r.payment_status === "paid");
  const revenue = paid.reduce((s, r) => s + (r.amount || 0), 0);

  return (
    <div data-testid="admin-orders">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <h3 className="font-serif text-2xl text-[#1F2A24]">Historique des commandes</h3>
        <div className="flex flex-wrap items-center gap-3">
          <div className="rounded-xl bg-[#F6F2E9] border border-[#E8DCC4] px-4 py-2 text-sm" data-testid="orders-summary">
            <span className="text-[#1F2A24]/60">Ventes payées :</span> <strong>{paid.length}</strong>
            <span className="text-[#1F2A24]/60 ml-3">CA :</span> <strong>{euros(revenue, "EUR")}</strong>
          </div>
          <select value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="orders-filter"
            className="rounded-full border border-[#E8DCC4] px-4 py-2 text-sm bg-white">
            <option value="all">Toutes</option>
            <option value="paid">Payées</option>
            <option value="pending">En attente</option>
            <option value="failed">Échouées</option>
          </select>
        </div>
      </div>

      <div className="overflow-x-auto rounded-xl border border-[#E8DCC4]">
        <table className="w-full text-sm" data-testid="orders-table">
          <thead className="bg-[#F6F2E9] text-[#1F2A24]/70 font-ui text-xs">
            <tr>{["N° commande", "Date", "Client", "Produit", "Montant", "Paiement", "Statut", "Accès attribués"].map((h) => (
              <th key={h} className="px-3 py-2 text-left whitespace-nowrap">{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={8} className="px-3 py-6 text-center text-[#1F2A24]/50">Aucune commande pour ce filtre.</td></tr>}
            {filtered.map((r) => (
              <tr key={r.order_number} data-testid={`order-row-${r.order_number}`} className="border-t align-top">
                <td className="px-3 py-2 font-mono text-xs whitespace-nowrap">{r.order_number}</td>
                <td className="px-3 py-2 whitespace-nowrap">{fmtDate(r.created_at)}</td>
                <td className="px-3 py-2">
                  {r.client_email || "—"}
                  {r.client_name ? <span className="block text-xs text-[#1F2A24]/50">{r.client_name}</span> : null}
                </td>
                <td className="px-3 py-2">{r.product}</td>
                <td className="px-3 py-2 whitespace-nowrap">{euros(r.amount, r.currency)}</td>
                <td className="px-3 py-2 uppercase text-xs">{r.provider}</td>
                <td className="px-3 py-2"><span className={`rounded-full px-2.5 py-1 text-[11px] ${statusStyle(r.payment_status)}`}>{r.payment_status}</span></td>
                <td className="px-3 py-2 text-xs">{(r.access || []).join(", ") || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="font-sans text-xs text-[#1F2A24]/50 mt-3">
        Les numéros de commande sont conservés pour votre suivi des ventes. Ceci est une confirmation/reçu de commande, non une facture fiscale.
      </p>
    </div>
  );
}
